const WALKABLE_CATS = new Set(["landmark", "street", "walk"]);

export const calcSmartDuration = (places) => {
  // Exclude food cards from activity time calculation
  const FOOD_CATS = new Set(["food", "foodie"]);
  const activityPlaces = places.filter(p => !FOOD_CATS.has((p.category || "").toLowerCase()));

  const byHood = {};
  const standalone = [];

  for (const p of activityPlaces) {
    const hood = (p.neighborhood || "").toLowerCase();
    if (!hood) { standalone.push(p); continue; }
    if (!byHood[hood]) byHood[hood] = { neighborhood: null, spots: [] };
    if (p.category === "neighborhood" || p.display_category === "Neighborhoods") {
      byHood[hood].neighborhood = p;
    } else {
      byHood[hood].spots.push(p);
    }
  }

  let totalDuration = 0;
  let transitGroups = 0;

  for (const hood of Object.values(byHood)) {
    const hoodDur = hood.neighborhood
      ? (hood.neighborhood.duration || hood.neighborhood.visit_duration_hours || 2)
      : 0;

    if (hood.neighborhood && hood.spots.length > 0) {
      let walkableTime = 0;
      let activityTime = 0;
      for (const s of hood.spots) {
        const dur = s.duration || s.visit_duration_hours || 1.5;
        WALKABLE_CATS.has((s.category || "").toLowerCase())
          ? (walkableTime += dur)
          : (activityTime += dur);
      }
      totalDuration += Math.max(hoodDur, walkableTime) + activityTime;
    } else if (hood.neighborhood) {
      totalDuration += hoodDur;
    } else {
      totalDuration += hood.spots.reduce((s, p) => s + (p.duration || p.visit_duration_hours || 1.5), 0);
    }
    transitGroups++;
  }

  totalDuration += standalone.reduce((s, p) => s + (p.duration || p.visit_duration_hours || 1.5), 0);
  transitGroups += standalone.length;
  const transitHours = Math.max(0, (transitGroups - 1) * 0.5);
  return { totalDuration, transitHours, totalNeeded: totalDuration + transitHours, groupCount: transitGroups };
};


/** Format decimal hours to human-readable: 1.5 → "1h 30min", 2 → "2h", 0.75 → "45min" */
export const formatDuration = (hours) => {
  if (!hours || hours <= 0) return "";
  // Round the whole duration, not just its minutes: 0.9h is "1h", never "60min".
  const total = Math.max(15, Math.round((hours * 60) / 15) * 15);
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (h > 0 && m > 0) return `${h}h ${m}min`;
  if (h > 0) return `${h}h`;
  return `${m}min`;
};
